import { createTheme, alpha } from '@mui/material'

const baseTheme = createTheme({
  /* COLORS */
  palette: {
    primary: {
      main: '#B246F6',
    },
    secondary: {
      main: '#B246F6',
    },
    success: {
      main: '#00C389',
    },
    error: {
      main: '#F8485E',
    },
    warning: {
      main: '#FCBA03',
    },
    background: {
      default: '#101011',
      paper: '#242D33',
    },
    text: {
      disabled: '#495A67',
      primary: '#BDBDBD',
      secondary: '#000000',
    },
    common: {
      white: '#FFFFFF',
      black: '#000000',
    },
    divider: '#242D33',
    mode: 'dark',
  },
  /* TYPOGRAPHY */
  typography: {
    fontFamily: 'Nunito-Sans',
    button: {
      textTransform: 'none',
      fontWeight: '600',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: '0.625rem',
          '&.Mui-disabled': {
            backgroundColor: alpha(theme.palette.primary.main, 0.25),
            color: theme.palette.common.white,
          },
        }),
      },
    },
  },
})

export default baseTheme
